import { useState, useContext, useEffect, useRef } from "react";
import PriceBadge from "../../Components/Step4/PriceBadge";
import "./step4.css";
import PortalContext from "../PortalContext";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  OverlayView,
} from "@react-google-maps/api";
import { sendGetRequest } from "../../Client";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import LpArrow from "../../Assets/Images/LP_Arrow.svg";

export default function Mobile(props) {
  const { portal } = useContext(PortalContext);

  const [selected, setSelected] = useState();

  const [loaded, setLoaded] = useState(false);

  const mapRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyC8kOFpMIzNKTgoey7z1yoGhXJOqtGYomg",
  });

  const scrollToMap = () => {
    mapRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const [loadingLocations, setLoadingLocations] = useState();

  const [availableLocations, setAvailableLocations] = useState();

  const [locationsContent, setLocationsContent] = useState();

  const [mapInstance, setMapInstance] = useState(null);

  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  const [selectedMarker, setSelectedMarker] = useState(false);

  const locations = async () => {
    setLoadingLocations(true);

    const res = await sendGetRequest(
      `api/v2-label-portal-services-dropoff-points.php?serviceProvider=${
        props.service.serviceProvider
      }&country=${portal?.step2?.country}&postcode=${encodeURIComponent(
        portal?.step2?.postcode
      )}&address1=${portal?.step2?.address1}&town=${
        portal?.step2?.town
      }&county=${portal?.step2?.county}&serviceExternalCode=${
        props.service.serviceExternalCode
      }&serviceID=${props.service.serviceID}`
    );

    setLoadingLocations(false);

    setLocationsContent(res.content);

    setLoaded(true);

    setAvailableLocations(res.locations);
  };

  useEffect(() => {
    locations();
  }, []);

  useEffect(() => {
    if (mapInstance && availableLocations?.length) {
      const bounds = new window.google.maps.LatLngBounds();
      availableLocations.forEach((location) => {
        bounds.extend({ lat: Number(location.lat), lng: Number(location.lng) });
      });

      if (!bounds.isEmpty()) {
        mapInstance.fitBounds(bounds);
      }
    }
  }, [mapInstance, availableLocations]);

  return (
    <>
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            border: "1px solid #ccc",
            borderRadius: 8,
            padding: "16px",
            marginBottom: "10px",
            width: "90%",
            marginLeft: "5%",
            backgroundColor: selected ? "#D3D3D3" : "#f8f9fa",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          <div style={{ flex: 1 }}>
            <a
              key={1234}
              onClick={() => setSelected(!selected)}
              style={{ textDecoration: "none" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "0px",
                  paddingTop: "0px",
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    color: "#003b71",
                    width: "60%",
                    textAlign: "left",
                  }}
                >
                  {props.service.serviceNameCustomer}
                </div>

                <PriceBadge text={props.service.formattedSellPrice} serviceProvider={props.service.serviceProvider}/>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "5px",
                }}
              >
                <div
                  style={{
                    fontStyle: "italic",
                    color: "#888",
                    fontSize: "14px",
                    width: "90%",
                  }}
                >
                  {props.service.serviceDetails}
                </div>
                <img
                  src={LpArrow}
                  alt="QR code"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginTop:
                      props.service.serviceDetails.length > 1 ? "0px" : "15px",
                    transform: selected ? "rotate(90deg)" : "rotate(0deg)",
                    transition: selected
                      ? "transform 0.3s ease"
                      : "transform 0.3s ease",
                  }}
                />
              </div>
            </a>

            {selected && (
              <div>
                {isLoaded && availableLocations?.length > 0 ? (
                  <>
                    {portal?.data?.settings?.googlemaps === true &&
                    localStorage.getItem("disableGoogleMaps") !== "true" ? (
                      <div
                        className="map-container"
                        ref={mapRef}
                        style={{ marginTop: "15px" }}
                      >
                        <GoogleMap
                          mapContainerStyle={containerStyle}
                          options={{
                            mapTypeControl: false,
                            fullscreenControl: false,
                            streetViewControl: false,
                            zoomControl: true,
                            cameraControl: false,
                          }}
                          onLoad={(map) => {
                            setMapInstance(map);
                          }}
                        >
                          <>
                            {selectedMarker && (
                              <OverlayView
                                position={{
                                  lat: selectedMarker.lat + 0.008,
                                  lng: selectedMarker.lng - 0.016,
                                }}
                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                              >
                                <div
                                  style={{
                                    background: "white",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    padding: "10px",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                                    maxWidth: "200px",
                                    position: "relative",
                                    width: "200px",
                                  }}
                                >
                                  <button
                                    style={{
                                      position: "absolute",
                                      top: "4px",
                                      right: "4px",
                                      border: "none",
                                      background: "transparent",
                                      cursor: "pointer",
                                      width: "20px",
                                      height: "20px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    onClick={() => setSelectedMarker(null)}
                                    aria-label="Close"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="25px"
                                      height="25px"
                                      viewBox="0 0 24 24"
                                      fill="black"
                                    >
                                      <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="black"
                                        strokeWidth="2"
                                      />
                                    </svg>
                                  </button>
                                  <strong>{selectedMarker.title}</strong>
                                </div>
                              </OverlayView>
                            )}

                            {availableLocations?.map((location, key) => (
                              <Marker
                                onClick={() => {
                                  setSelectedMarker(location);
                                  if (mapInstance) {
                                    mapInstance.setZoom(13);
                                    mapInstance.panTo({
                                      lat: Number(location.lat),
                                      lng: Number(location.lng),
                                    });
                                  }
                                }}
                                key={key}
                                position={{
                                  lat: Number(location.lat),
                                  lng: Number(location.lng),
                                }}
                              />
                            ))}
                          </>
                        </GoogleMap>
                      </div>
                    ) : null}

                    {availableLocations.map((location, key) => (
                      <div
                        key={key}
                        className="cursor-pointer"
                        onClick={() => {
                          setSelectedMarker(location);
                          if (mapInstance) {
                            mapInstance.setZoom(13);
                            mapInstance.panTo({
                              lat: Number(location.lat),
                              lng: Number(location.lng),
                            });
                          }
                          scrollToMap();
                        }}
                      >
                        <div
                          className="service-title mt-4"
                          style={{
                            color: `${portal.data.settings.colours.primary}`,
                          }}
                        >
                          {location.title}
                        </div>
                        <div className="service-body">{location.address}</div>
                        <div className="service-body">{location.price}</div>
                      </div>
                    ))}
                  </>
                ) : (
                  <div
                    style={{
                      textAlign: "left",
                      fontWeight: 400,
                      fontSize: "14px",
                      color: portal.data.settings.colours.primary,
                    }}
                    className="mt-4"
                    dangerouslySetInnerHTML={{ __html: locationsContent }}
                  />
                )}

                {!loaded ? (
                  <Skeleton width={"100%"} height={"50px"} />
                ) : (
                  <div
                    style={{
                      backgroundColor: portal.data.settings.colours.primary,
                      color: "white",
                      borderRadius: "5px",
                      padding: "10px 20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      minWidth: "180px",
                      maxWidth: "100%",
                      height: "40px",
                      marginTop: "15px",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      props.onSubmit?.(props.service);
                    }}
                  >
                    <span>Get {props.service.serviceNameCustomer} label</span>
                    <span style={{ marginLeft: "10px", fontSize: "16px" }}>
                      &rsaquo;
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </>
    </>
  );
}
